// src/components/affiliate/AffiliateBooking.js

export default function AffiliateBooking() {
  return (
    <div
      style={{
        width: "420px",          // ⭐ PERFECT SIZE FOR BOOKING
        margin: "10px auto",
        transition: "all 0.25s ease",
        boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
        borderRadius: "8px",
        overflow: "hidden",
      }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = "translateY(-3px)";
        e.currentTarget.style.boxShadow = "0 6px 14px rgba(0,0,0,0.25)";
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = "translateY(0)";
        e.currentTarget.style.boxShadow = "0 4px 10px rgba(0,0,0,0.15)";
      }}
    >
      <a
        href="https://www.tkqlhce.com/click-101530017-17289075"
        target="_blank"
        rel="noopener noreferrer"
      >
        <img
          src="https://www.ftjcfx.com/image-101530017-17289075"
          alt="CJ Affiliate Banner"
          style={{
            width: "100%",       // fills wrapper
            height: "auto",      // keeps perfect proportions
            display: "block",
            cursor: "pointer",
          }}
        />
      </a>
    </div>
  );
}
